import { DocumentNode } from 'graphql';
import {
  gql, QueryHookOptions, useLazyQuery, useQuery,
} from '@apollo/client';
import { ICompanyShowcaseCategorySchemaPartial, ICompanyShowcaseCategorySchema } from '../../type/companyShowcaseCategory';
import { IWithPagination, DeepPartial } from '../_module/baseQueryType';



export interface ICompanyShowcaseCategoryVars {
  
 filter: {
  _id?: string;
  _ids?: string[];
  status?: boolean;
  featured?: boolean;
  slug?: string;
  companyId?: string;
  root?: boolean;
  anyClassificationIds?: string[];
  anyBrandsIds?: string[];
  anyTagsIds?: string[];
}
 sort: {
  _id?: number;
  position?: number;
}
 search: {
  _id?: string;
  name?: string;
}
 skip?: number
 limit?: number
 
  
  
  
  
 
}
export const CompanyShowcaseCategoryQueryTypeDefinitionKey = 'CompanyShowcaseCategory';
export type ICompanyShowcaseCategoryVarsPartial = Partial<ICompanyShowcaseCategoryVars>
export type ICompanyShowcaseCategoryDataPartial = DeepPartial<ICompanyShowcaseCategorySchemaPartial>
export interface ICompanyShowcaseCategoryQueryData<TData extends ICompanyShowcaseCategorySchema = ICompanyShowcaseCategorySchema>{
  

    companyShowcaseCategories: IWithPagination<TData>
}

export function companyShowcaseCategoryQuery(fragment: string, rootFragment?: string, withPagination?: boolean): DocumentNode {
  return gql`
        query 

    companyShowcaseCategories(
        $filter: CompanyShowcaseCategoryQueryFilterParameterInput,
$search: CompanyShowcaseCategoryQuerySearchParameterInput,
$sort: CompanyShowcaseCategoryQuerySortParameterInput,
$skip: Int,
$limit: Int
        ){
        

    companyShowcaseCategories(
        filter: $filter,
search: $search,
sort: $sort,
skip: $skip,
limit: $limit
        ){
          items {
              ${fragment}
          }
          ${withPagination ? `
          pagination {
            total
            perPage
            currentPage
            hasNextPage
            totalPage
          }
          ` : ''}
          ${rootFragment || ''}
        }
        }
    `;
}

export function useCompanyShowcaseCategoryLazyQuery<TData extends ICompanyShowcaseCategorySchema>(
  fragment: string,
  options?: QueryHookOptions<ICompanyShowcaseCategoryQueryData<TData>, ICompanyShowcaseCategoryVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useLazyQuery<ICompanyShowcaseCategoryQueryData<TData>, ICompanyShowcaseCategoryVarsPartial>(companyShowcaseCategoryQuery(fragment, rootFragment, withPagination), options);
}

export function useCompanyShowcaseCategoryQuery<TData extends ICompanyShowcaseCategorySchema>(
  fragment: string,
  options?: QueryHookOptions<ICompanyShowcaseCategoryQueryData<TData>, ICompanyShowcaseCategoryVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useQuery<ICompanyShowcaseCategoryQueryData<TData>, ICompanyShowcaseCategoryVarsPartial>(companyShowcaseCategoryQuery(fragment, rootFragment, withPagination), options);
}
